import { withNamespaces } from "react-i18next"
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

const OutofBoundaryModal = ({ t, isOpen, toggle, title, body }) => {
    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
                <div className="text-danger d-flex justify-content-center align-items-center">
                    <i className="ri-error-warning-line me-2"></i>
                    {title}
                </div>
            </ModalHeader>
            <ModalBody>
                {body}
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={toggle}>
                    {t('OK')}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default withNamespaces()(
    OutofBoundaryModal
)